import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import WebinarPost from "@/pages/WebinarPost";

export const Route = createFileRoute("/es/webinars/$slug")({
  loader: ({ params }) => loadContentMeta("webinars", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/webinars/${params.slug}`, loaderData),
  component: WebinarPost,
});

